module.exports = __webpack_public_path__ + "media/images/register/img_register_flow-bf3ae96e2ed1801daa482a362bf17311.png";